import apiClient from '../../apiClient';
import '../../App.css'
import { useEffect, useState } from 'react';
import { DataGrid } from '@mui/x-data-grid'
import { GetZPercent, GetMean, GetStandardDeviation } from '../universal/InternalCalculator';
import { CustomToolbar } from '../universal/GridHelper';

const ConvertDataToRows = (data, dncList) => {
    let finalResults = []
    let all_scores = data.map(d => d["scores"]).flat()
    let mean = GetMean(all_scores)
    let standardDeviation = GetStandardDeviation(all_scores)
    data.map(x => {
        let rowData = {}
        rowData["id"] = x["snsi_id"]
        rowData["audio_file_name"] = x["audio_file_name"]
        let i = 0;
        dncList.map((dnc) => {
            rowData[dnc] = x["scores"][i]
            rowData[dnc + "_percentile"] = GetZPercent((x["scores"][i] - mean) / standardDeviation).toFixed(2)
            rowData[dnc + "_network_run_id"] = x["network_run_ids"][i]
            i++
        });
        finalResults.push(rowData)
    })
    return finalResults
}

const GetComparativeSetDensityNetworkConfigResultsColumns = (dncList) => {
    const comparativeSetDensityNetworkConfigResultsColumns = [
        {
            field: 'id',
            headerName: 'SNSI ID',
            width: 340,
            hide: true
        },
        {
            field: 'audio_file_name',
            headerName: 'Audio File Name',
            width: 380,
        }
    ];
    dncList.map((dnc) => {
        let relative_performance = dnc + "_percentile"
        let network_run_id = dnc + "_network_run_id"
        comparativeSetDensityNetworkConfigResultsColumns.push({
            field: dnc,
            headerName: dnc,
            width: 80,
            renderCell: (params) => (
                params.value != null ?
                    <a style={{
                        color: 'rgb(' + ((1 - parseFloat(params.row[relative_performance])) * 255) + ',' + (parseFloat(params.row[relative_performance]) * 255) + ',0)' 
                    }} href={"output-files?id=" + params.row[network_run_id] + "&snsi_id=" + params.row.id} target="_blank">
                        <span style={{ textDecoration: 'none', }}
                    >
                    {params.value.toString()}
                        </span> 
                    </a> : <span></span>
            ),
        })
    })
    return comparativeSetDensityNetworkConfigResultsColumns
}

const ComparativeSetDensityNetworkConfigResultsTable = ({ comparative_set_id, density_network_config_id_list, score_metric }) => {
    const [comparativeSetDensityNetworkConfigData, setComparativeSetDensityNetworkConfigData] = useState([])
    const [comparativeSetDensityNetworkConfigResultsData, setComparativeSetDensityNetworkConfigResultsData] = useState([]);
    const [comparativeSetDensityNetworkConfigResultsColumns, setComparativeSetDensityNetworkConfigResultsColumns] = useState([]);

    const getResultsFromComparativeSetDensityNetworkConfigCombos = () => {
        apiClient.post(
            "https://us-central1-airy-semiotics-297902.cloudfunctions.net/interactive-density-network",
            {
                "function_to_execute": "Get_Results_From_Comparative_Set_Density_Network_Config_Combos",
                "comparative_set_id": comparative_set_id,
                "density_network_config_ids": density_network_config_id_list,
                "score_metric": score_metric
            }
        ).then((response) => {
            setComparativeSetDensityNetworkConfigData(response.data)
        }).catch(function (error) {

        });
    }

    useEffect(() => {
        setComparativeSetDensityNetworkConfigData([])
        getResultsFromComparativeSetDensityNetworkConfigCombos()
    }, [score_metric]);

    useEffect(() => {
        setComparativeSetDensityNetworkConfigResultsData(ConvertDataToRows(comparativeSetDensityNetworkConfigData, density_network_config_id_list))
        if (comparativeSetDensityNetworkConfigData.length > 0) {
            setComparativeSetDensityNetworkConfigResultsColumns(GetComparativeSetDensityNetworkConfigResultsColumns(density_network_config_id_list))
        }
    }, [comparativeSetDensityNetworkConfigData, score_metric])

    if (comparativeSetDensityNetworkConfigData.length === 0) {
        return <p>loading...</p>
    }
    else {
        return (
            <DataGrid
                rows={comparativeSetDensityNetworkConfigResultsData}
                columns={comparativeSetDensityNetworkConfigResultsColumns}
                initialState={{
                    sorting: {
                        sortModel: [{ field: 'id', sort: 'desc' }],
                    },
                }}
                components={{
                    Toolbar: () => CustomToolbar("Comparative_Set_" + comparative_set_id + "_DNC_Results")
                }}
            />
        )
    }
};

export { ComparativeSetDensityNetworkConfigResultsTable };
